// Single source of truth for the official engine count.
// Update HERE ONLY — every page badge, stat, FAQ, and schema reads this.
export const ENGINE_COUNT = 26;
